/**
 * Default factory providing game objects.
 * Methods can be overridden in games for customizing components.
 *
 * UPDATE: getClass should be invoked to get a given class instance.
 * All other methods should be protected in order to be overridden
 */
import InterractionManager from "../../src/ui/InteractionManager";
import PreloadView from "../../src/views/PreloadView";
import Reel from "../../src/views/Reel";
import ReelGroup from "../../src/views/ReelGroup";
import ReelSymbol from "../../src/views/Symbol";
import WinlinesView from "../../src/views/WinlinesView";
import WinSymbolsView from "../../src/views/WinSymbolsView";
import BaseAnticipation from "../views/BaseAnticipation";
import ReelVerticalSpinBehaviour from "../../src/spinners/ReelVerticalSpinBehaviour";
import SymbolAnimation from "../views/SymbolAnimation";
import { MoneyField } from "../views/MoneyField";
import { MoneyFieldConfig, AbstractMoneyField } from "../views/AbstractMoneyField";
import { BitmapMoneyFieldConfig, AbstractBitmapMoneyField } from "../views/AbstractBitmapMoneyField";
import { BitmapMoneyField } from "../views/BitmapMoneyField";
import MessagePopup from '../ui/popups/MessagePopup';
import ErrorPopup from '../ui/popups/ErrorPopup';
import { SimpleWheel } from './../views/SimpleWheel'

export class BaseGameFactory {

    protected getInterractionManager() {
        return new InterractionManager();
    }

    protected getMoneyField(config?: MoneyFieldConfig): AbstractMoneyField {
        return new MoneyField(config);
    }

    protected getBitmapMoneyField(config?: BitmapMoneyFieldConfig): AbstractBitmapMoneyField {
        return new BitmapMoneyField(config)
    }

    protected getPreloadView() {
        return new PreloadView();
    }

    protected getSymbol() {
        return new ReelSymbol();
    }

    protected getReelGroup() {
        return new ReelGroup();
    }

    protected getReel(params: {reelGroup: any, container: any, reelIdx: any}) {
        return new Reel(params.container, params.reelIdx);
    }

    protected getWinlinesView() {
        return new WinlinesView();
    }

    protected getWinSymbolsView() {
        return new WinSymbolsView();
    }

    protected getSymbolAnimation() {
        return new SymbolAnimation();
    }

    protected getAnticipation() {
        return new BaseAnticipation();
    }

    protected getFreeSpinBehaviour(params: {reel: Reel, sortFunction: any}) {
        return new ReelVerticalSpinBehaviour(params.reel, params.sortFunction );
    }

    protected getRespinBehaviour(params: {reel: Reel, sortFunction: any}) {
        return new ReelVerticalSpinBehaviour(params.reel, params.sortFunction );
    }

    protected getSpinBehaviour(params: {reel: Reel, sortFunction: any}) {
        return new ReelVerticalSpinBehaviour(params.reel, params.sortFunction );
    }
    protected getMessagePopup() {
        return new MessagePopup();
    }
    protected getErrorPopup() {
        return new ErrorPopup();
    }

       protected getSimpleWheel() {
        return new SimpleWheel();
    }
}

export default BaseGameFactory;
